import {AuthService} from "./AuthService";

export class ProductViolationService {
    url = `product_violations/`;

    getProductViolationStrategySchedule(product_id){
        return AuthService.apiGet(this.url + "violation_strategy_schedule/", {params: {"product_id": product_id}}).then(res => res.data.data);
    }
}
